import { MapProvider } from 'ms-map-gl'
import { useEffect, useMemo } from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import { StateProvider as FeatureInfoProvider } from '~map-feature-info/states/provider'

import { useIsSSR } from 'ssr/useIsSSR'
import { Map } from '~map-preview/types/__generated/gql/graphql'
import { createStore } from './store'

type StateProviderProps = {
  mapId: string
  map?: Map
  userId?: string
  children: any
}

const StateProvider = (props: StateProviderProps) => {
  const { children, mapId, map, userId } = props

  const { store, persistor } = useMemo(
    () => createStore(map, mapId, userId),
    [userId, map, mapId]
  )

  const isSSR = useIsSSR()
  useEffect(() => {
    if (!isSSR) persistor.persist()
  }, [persistor, isSSR])

  return (
    <Provider store={store}>
      <PersistGate
        loading={children}
        persistor={persistor}
      >
        {children}
      </PersistGate>
    </Provider>
  )
}

const providers = (Component) => (props) => {
  return (
    <MapProvider>
      <FeatureInfoProvider>
        <StateProvider {...props}>
          <Component {...props} />
        </StateProvider>
      </FeatureInfoProvider>
    </MapProvider>
  )
}

export { providers, StateProvider }
